<i18n>
{
  "en": {
    "more": "See more",
    "description": "Fill missing product information in order to improve Dynameat predictions"
  },
  "es": {
    "more": "Ver más",
    "description": "Completa la información de tus productos para mejorar las predicciones de Dynameat"
  }
}
</i18n>
<template>
  <v-card class="d-grid custom-grid ma-2">
    <v-progress-circular :rotate="rotation" :size="150" :width="15" :value="calculatedValue"
                         :indeterminate="!calculatedValue" color="primary"
                         class="graph grid-center-y grid-center-x ma-2">
      <div v-if="calculatedValue" class="text-h3">{{displayValue}}%</div>
    </v-progress-circular>
    <div class="text ma-1 grid-end-y grid-center-x text-center">
      {{$t('description')}}
    </div>
    <v-btn v-on="$listeners" color="primary" max-width="100" class="button grid-center-y grid-center-x | ma-1">
      {{ $t('more') }}
    </v-btn>
  </v-card>
</template>
<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { MapGetters } from '@core/helpers/decorators';

@Component
@MapGetters(['profilePercentage'])
export default class CompletionWidget extends Vue {
  get calculatedValue() {
    return this.profilePercentage || undefined;
  }

  get displayValue() {
    return this.calculatedValue || '';
  }

  get rotation() {
    return this.calculatedValue ? 270 : 0;
  }
}
</script>
<style scoped>
.custom-grid {
  max-width: 600px;
  width: 90%;
  grid-template-columns: auto auto;
  grid-template-rows: auto auto;
  grid-template-areas:
    "graph text"
    "graph button";
}

.graph {
  grid-area: graph;
}

.text {
  grid-area: text;
}

.button {
  grid-area: button;
}
</style>
